/**
 * This component represents an individual item in the multi-select drop-down
 */
import React, { useRef } from "react";
import { useKey } from "../hooks/use-key";
import { KEY } from "../lib/constants";
import DefaultItemRenderer from "./default-item";

var SelectItem = _ref => {
  var {
    itemRenderer: ItemRenderer = DefaultItemRenderer,
    option,
    checked,
    tabIndex,
    disabled,
    onSelectionChanged,
    onClick
  } = _ref;
  var itemRef = useRef();

  var onOptionCheck = e => {
    toggleChecked();
    e.preventDefault();
  };

  var toggleChecked = () => {
    if (!disabled) {
      onSelectionChanged(!checked);
    }
  };

  var handleClick = e => {
    toggleChecked();
    onClick(e);
  };

  useKey([KEY.ENTER, KEY.SPACE], onOptionCheck, {
    target: itemRef
  });
  return /*#__PURE__*/React.createElement("label", {
    className: "select-item " + (checked && "selected"),
    role: "option",
    "aria-selected": checked,
    tabIndex: tabIndex,
    ref: itemRef
  }, /*#__PURE__*/React.createElement(ItemRenderer, {
    option: option,
    checked: checked,
    onClick: handleClick,
    disabled: disabled
  }));
};

export default SelectItem;
//# sourceMappingURL=select-item.js.map